import React, { useRef, useEffect } from 'react'
import { RemixLoader } from 'remix/src/loader'

const RemixViewer = ({ remixUrl, device }) => {
    const previewRef = useRef()

    useEffect(() => {
        if (remixUrl) {
            const loader = new RemixLoader({
                mode: 'preview',
                nodeElement: previewRef.current,
                remixUrl: remixUrl,
            })

            loader.createIframe()

            return () => {
                if (loader) {
                    loader.destroyIframe()
                }
            }
        }
    }, [remixUrl])

    return (
        <div className={`iframe_wrapper ${device}`}>
            <div className="iframe_inner">
                <div ref={previewRef} />
            </div>
        </div>
    )
}

export default RemixViewer
